export default __webpack_public_path__ + "36168646e7d919287d074c83d2ea3cde.woff2";